"use client"

import { Show, SignInButton, SignUpButton, UserButton, useUser } from '@clerk/nextjs'
import Link from 'next/link'
import { usePathname } from 'next/navigation';
import React, { useState } from 'react'
import { Menu, X, ChevronDown } from 'lucide-react'
import CustomUserButton from './CustomUserButton';
import { ShowIfRole } from './ShowIfRole';

const ADMIN_ID = "user_3AtnbF82V4ROWYZ4rH2PlrSsvGk";

const NewHeader = () => {
    const pathname = usePathname();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState<string | null>(null);

    const zIndex = pathname === "/subscribe" ? "z-0" : "z-10"

    const { user: clerkUser } = useUser();
    const role = clerkUser?.publicMetadata?.role;

    const isAdmin = clerkUser?.id === ADMIN_ID;

    const sections = [
        {
            title: "",
            links: [
                //{ name: "Holy Seat", href: "/holy-seat" },
                //{ name: "Palace", href: "/palace" },
                //{ name: "Cathedral", href: "/cathedral" },
                //{ name: "Seat", href: "/palace" },
                //  { name: "Church", href: "/church" },
                // { name: "Fraternity", href: "/fraternity" },
                {name: "Convention of Fathers", href: "/assembly/convention-of-fathers"},
                {name: "Grand Council of Lords", href: "/assembly/grand-council"},
                {name: "Great Hall of Gentry", href: "/assembly/great-hall"},
                {name: "General Congregation", href: "/assembly/general-congregation"}
            ]
        },/*
        {
            title: "Middle Society",
            links: [
                { name: "Head Office", href: "/office" },
                { name: "Assembly", href: "/assembly" },
                { name: "Forum", href: "/forum" },
            ]
        },
        {
            title: "Low Society",
            links: [
                { name: "School", href: "/school" },
                { name: "Guild", href: "/guild" },
                { name: "Journals", href: "/journals" },
            ]
        }*/
    ]

    const dataLinks = [

        { name: "Rules", href: "/rules" },
    ]

    const handleDropdownToggle = (dropdown: string) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
    }

    const handleLinkClick = () => {
        setIsMenuOpen(false);
        setOpenDropdown(null);
    }

    return (
        <header className={`sticky top-0 ${zIndex} w-full border-b-4 border-red-700 bg-slate-900 backdrop-blur-md border-b border-red-800 shadow-xl`}>
            <div className="mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">

                {/* Brand/Logo Area */}
                <div className="flex items-center">
                    <Link href="/" className="text-white flex flex-row font-serif font-bold text-xl tracking-tighter">
                        <img src="/img/stars.svg" width={25} className='mr-2' />
                        <span className="hidden lg:inline">Holy Empire of America</span>
                        <span className="hidden md:inline lg:hidden">Holy Empire of America</span>
                        <span className="md:hidden text-2xl tracking-widest">HEA</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className='ml-2 mt-1' viewBox="0 0 768 1024" width="24" height="24" fill="#924900ff"><path d="M704 512H512v448q0 26-18.5 45t-45.5 19H320q-26 0-45-19t-19-45V512H64q-26 0-45-19T0 448V320q0-27 18.5-45.5T64 256h192V64q0-27 19-45.5T320 0h128q27 0 45.5 18.5T512 64v192h192q27 0 45.5 18.5T768 320v128q0 26-18.5 45T704 512" /></svg>
                    </Link>
                </div>

                {/* Desktop Navigation Links */}
                <nav className="hidden xl:flex items-center gap-1 sm:gap-2">
                    <div className="flex items-center mr-4 gap-4">

                        <Link href="/bible" className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200 flex items-center gap-1">
                            Bible

                        </Link>

                        {/* Assembly Dropdown */}


 {/* Resources Dropdown */} 
                        <div className="relative group">
                            <button className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200 flex items-center gap-1">
                                About
                                <ChevronDown size={14} className="group-hover:text-amber-400 transition-colors" />
                            </button>
                            <div className="absolute left-0 pb-1 mt-0 w-40 bg-slate-800 border border-slate-700 rounded-sm shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 pt-2 z-50">
                                <a
                                    href="/code"
                                    //target="_blank"
                                    rel="noopener noreferrer"
                                    className="block px-4 py-2 text-xs text-slate-300 hover:text-white hover:bg-slate-700/50 transition-all"
                                >
                                    Code
                                </a>
                                   <a
                                    href="/laws"
                                    //target="_blank"
                                    rel="noopener noreferrer"
                                    className="block px-4 py-2 text-xs text-slate-300 hover:text-white hover:bg-slate-700/50 transition-all"
                                >
                                    Laws
                                </a>
                                <a
                                    href="/code/declaration-of-sovereignty"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block px-4 py-2 text-xs text-slate-300 hover:text-white hover:bg-slate-700/50 transition-all"
                                >
                                    Who We Are
                                </a>
                             
                                <a
                                    href="https://discord.gg/Nr8dXdueY7"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block px-4 py-2 text-xs text-slate-300 hover:text-white hover:bg-slate-700/50 transition-all"
                                >
                                    Discord
                                </a>
                                {/*    <ShowIfRole role="no-use">
                                    <a
                                        href="https://buy.stripe.com/6oU4gzd0K4ul6BfeXSdUY01"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block px-4 py-2 text-xs text-slate-300 hover:text-white hover:bg-slate-700/50 transition-all"
                                    >
                                        Membership Fee
                                    </a>
                                </ShowIfRole> */}

                            </div>
                        </div>
                        {/* Societies Dropdown  F
                          <ChevronDown size={14} className="group-hover:text-amber-400 transition-colors" />
                        <div className="absolute left-0 mt-0 w-32 bg-slate-800 border border-slate-700 rounded-sm shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 pt-2 z-50">
                                {sections.map((section, idx) => (
                                    <div key={section.title}>
                                        <div className="px-4 -mt-1.5 py-2">

                                            {section.links.map((link) => (
                                                <Link
                                                    key={link.href}
                                                    href={link.href}
                                                    className="block text-xs text-slate-300 hover:text-white hover:pl-1 transition-all py-1.5"
                                                >
                                                    {link.name}
                                                </Link>
                                            ))}
                                        </div>
                                        {idx < sections.length - 1 && <div className="border-t border-slate-700" />}
                                    </div>
                                ))}
                            </div>

 */}
                        <div className="relative group">
                            <Link href="/palace" className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200 flex items-center gap-1">
                                Founding Father
                              
                            </Link>
                            

                        </div>
                        <div className="relative group">
                            <Link href="/assembly" className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200 flex items-center gap-1">
                                Assembly
                            <ChevronDown size={14} className="group-hover:text-amber-400 transition-colors" />
                            </Link>
                             <div className="absolute left-0 mt-0 w-42 bg-slate-800 border border-slate-700 rounded-sm shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 pt-2 z-50">
                                {sections.map((section, idx) => (
                                    <div key={section.title}>
                                        <div className="px-4 -mt-1.5 py-2">

                                            {section.links.map((link) => (
                                                <Link
                                                    key={link.href}
                                                    href={link.href}
                                                    className="block text-xs text-slate-300 hover:text-white hover:pl-1 transition-all py-1.5"
                                                >
                                                    {link.name}
                                                </Link>
                                            ))}
                                        </div>
                                        {idx < sections.length - 1 && <div className="border-t border-slate-700" />}
                                    </div>
                                ))}
                            </div>
                              
                        </div>
                        {/*
                         <div className="absolute pb-1 left-0 mt-0 w-36 bg-slate-800 border border-slate-700 rounded-sm shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 pt-2 z-50">
                                <Link
                                    href="/assembly"
                                    className="block px-4 py-2 text-xs text-slate-300 hover:text-white hover:bg-slate-700/50 transition-all"
                                >
                                    General Assembly
                                </Link>
                            <Link
                                    href="/rules"
                                    className="block px-4 py-2 text-xs text-slate-300 hover:text-white hover:bg-slate-700/50 transition-all"
                                >
                                    Rules
                                </Link> 
                            </div> 
                        
                        
                        Data Dropdown  <div className="relative group">
                            <button className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200 flex items-center gap-1">
                                Assets
                                <ChevronDown size={14} className="group-hover:text-amber-400 transition-colors" />
                            </button>
                            <div className="absolute left-0 mt-0 w-32 bg-slate-800 border border-slate-700 rounded-sm shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 pt-2 z-50">
                                {dataLinks.map((link) => (
                                    <Link
                                        key={link.href}
                                        href={link.href}
                                        className="block px-4 py-2 text-xs text-slate-300 hover:text-white hover:bg-slate-700/50 transition-all"
                                    >
                                        {link.name}
                                    </Link>
                                ))}
                            </div>
                        </div>*/}
                        <Link href="/church" className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200 flex items-center gap-1">
                            Church

                        </Link>

                       

                        <Show when={(has) => has({ plan: 'pro' }) || has({ plan: 'elite' }) || isAdmin} >
                            <Link href="/assistant" className="text-amber-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200 flex items-center gap-1">
                                Assistant
                            </Link>
                        </Show>
                        {/*} <div className="relative group">
                            <button className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200 flex items-center gap-1">
                                Tools
                                <ChevronDown size={14} className="group-hover:text-amber-400 transition-colors" />
                            </button>
                            <div className="absolute left-0 mt-0 w-40 bg-slate-800 border border-slate-700 rounded-sm shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 pt-2 z-50">
                                <a
                                    href="/assistant"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block px-4 py-2 text-xs text-amber-300 hover:text-white hover:bg-slate-700/50 transition-all"
                                >
                                    Assistant
                                </a>
                                <a
                                    href="/flashcards"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block px-4 py-2 text-xs text-amber-300 hover:text-white hover:bg-slate-700/50 transition-all"
                                >
                                    Flashcards
                                </a>
                             

                            </div>
                        </div>  */}




                        {/* Subscribe Link */}

                        <Link
                            href="/subscribe"
                            className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200"
                        >
                            Subscribe
                        </Link>

                        {role === "accepted_member-no" && (
                            <Show when="signed-in" >
                                <Link href="/membership" className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200 flex items-center gap-1">
                                    Membership
                                </Link>
                            </Show>
                        )}

                        {role !== "accepted_member" && role !== "newcomer" && false && (
                            <Show when="signed-in" >
                                <Link href="/apply" className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors duration-200 flex items-center gap-1">
                                    Apply
                                </Link>
                            </Show>
                        )}




                    </div>

                    <div className="h-6 w-px bg-slate-700 mx-2 hidden md:block" />

                    <div className="flex items-center gap-3 ml-2">
                        <Show when="signed-out">
                            <SignInButton>
                                <button className="text-slate-300 hover:text-white text-xs uppercase tracking-widest font-bold py-2 px-3 transition-all">
                                    Sign In
                                </button>
                            </SignInButton>
                            <SignUpButton>
                                <button className="bg-amber-800 hover:bg-amber-900 text-white text-[10px] uppercase tracking-[0.2em] font-bold px-5 py-2.5 rounded-sm transition-all shadow-lg active:scale-95">
                                    Sign Up
                                </button>
                            </SignUpButton>
                        </Show>

                        <Show when="signed-in">
                            <div className="pl-2 border-slate-700 -ml-2">
                                <CustomUserButton username={clerkUser?.username} />
                            </div>
                        </Show>
                    </div>
                </nav>

                {/* Mobile Toggle and Avatar */}
                <div className="xl:hidden flex items-center gap-4">
                    <Show when="signed-in">
                        <CustomUserButton username={clerkUser?.username} />
                    </Show>
                    <button
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className="text-slate-300 hover:text-white"
                    >
                        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Dropdown */}
            {isMenuOpen && (
                <div className="xl:hidden bg-slate-900 border-b border-slate-700 px-4 py-6 space-y-4">


                    <Link
                        href="/bible"
                        className="flex items-center justify-between w-full text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                    >
                        Bible
                    </Link>


<div>
                        <button
                            onClick={() => handleDropdownToggle('resources')}
                            className="flex items-center justify-between w-full text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                        >
                            About
                            <ChevronDown size={16} className={`transform transition-transform ${openDropdown === 'resources' ? 'rotate-180' : ''}`} />
                        </button>
                        {openDropdown === 'resources' && (
                            <div className="mt-3 ml-4 space-y-2 border-l-2 border-slate-700 pl-4">
                                 <a
                                    href="/code"
                                    //target="_blank"
                                    rel="noopener noreferrer"
                                    className="block text-xs text-slate-400 hover:text-white"
                                >
                                    Code
                                </a>
                                <a
                                    href="/laws"
                                    //target="_blank"
                                    rel="noopener noreferrer"
                                    className="block text-xs text-slate-400 hover:text-white"
                                >
                                    Laws
                                </a>
                                <a
                                    href="/code/declaration-of-sovereignty"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block text-xs text-slate-400 hover:text-white"
                                >
                                    Who We Are
                                </a>
                                
                                <a
                                    href="https://discord.gg/Nr8dXdueY7"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block text-xs text-slate-400 hover:text-white"
                                >
                                    Discord
                                </a>
                                {/*}
                                <ShowIfRole role="no-use">
                                    <a
                                        href="https://buy.stripe.com/6oU4gzd0K4ul6BfeXSdUY01"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block text-xs text-slate-400 hover:text-white"
                                    >
                                        Membership Fee
                                    </a>
                                </ShowIfRole>
                                */}
                            </div>
                        )}
                    </div>

                    

                    {/* Mobile Societies  <ChevronDown size={16} className={`transform transition-transform ${openDropdown === 'societies' ? 'rotate-180' : ''}`} />
                   */}
                    <div>
                        <Link
                            href="/palace"
                            onClick={() => handleDropdownToggle('divisions')}
                            className="flex items-center justify-between w-full text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                        >
                            Founding Father
                                </Link>
                        {openDropdown === 'divisions' && false && (
                            <div className="mt-3 ml-4 space-y-3 border-l-2 border-slate-700 pl-4">
                                {sections.map((section) => (
                                    <div key={section.title}>
                                        <h4 className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-500 mb-2">
                                            {section.title}
                                        </h4>
                                        {section.links.map((link) => (
                                            <Link
                                                key={link.href}
                                                href={link.href}
                                                onClick={handleLinkClick}
                                                className="block text-xs text-slate-400 hover:text-white py-1"
                                            >
                                                {link.name}
                                            </Link>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Mobile Assembly 
                    <div className="">
                        <div className="flex items-center justify-between w-full hover:text-white "  >
                            <Link
                                href="/assembly"
                                onClick={handleLinkClick}
                                className="text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                            >
                                Assembly
                            </Link>
                            <button
                                onClick={() => handleDropdownToggle('assembly')}
                                className="text-slate-300 hover:text-white flex items-center flex-1 justify-end pl-2"
                            >
                                <ChevronDown size={16} className={`transform transition-transform ${openDropdown === 'assembly' ? 'rotate-180' : ''}`} />
                            </button> 
                        </div>
                        {openDropdown === 'assembly' && (
                            <div className="mt-3 ml-4 space-y-2 border-l-2 border-slate-700 pl-4">
                                <Link
                                    href="/assembly"
                                    onClick={handleLinkClick}
                                    className="block text-xs text-slate-400 hover:text-white"
                                >
                                    General Assembly
                                </Link>
                                <Link
                                    href="/code"
                                    onClick={handleLinkClick}
                                    className="block text-xs text-slate-400 hover:text-white"
                                >
                                    Code
                                </Link>
                            </div>
                        )}
                    </div> */}

                    {/* Mobile Data  <div>
                        <button
                            onClick={() => handleDropdownToggle('data')}
                            className="flex items-center justify-between w-full text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                        >
                            Assets
                            <ChevronDown size={16} className={`transform transition-transform ${openDropdown === 'data' ? 'rotate-180' : ''}`} />
                        </button>
                        {openDropdown === 'data' && (
                            <div className="mt-3 ml-4 space-y-2 border-l-2 border-slate-700 pl-4">
                                {dataLinks.map((link) => (
                                    <Link
                                        key={link.href}
                                        href={link.href}
                                        onClick={handleLinkClick}
                                        className="block text-xs text-slate-400 hover:text-white"
                                    >
                                        {link.name}
                                    </Link>
                                ))}
                            </div>
                        )} 
                    </div> */}
                    <Link
                        href="/assembly"
                        className="flex items-center justify-between w-full text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                    >
                        Assembly
                    </Link>
                    <Link
                        href="/church"
                        className="flex items-center justify-between w-full text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                    >
                        Church
                    </Link>


                    {/* Mobile Resources */}
                    

                    {/*}  <div>
                        <button
                            onClick={() => handleDropdownToggle('tools')}
                            className="flex items-center justify-between w-full text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                        >
                            Tools
                            <ChevronDown size={16} className={`transform transition-transform ${openDropdown === 'tools' ? 'rotate-180' : ''}`} />
                        </button>
                        {openDropdown === 'tools' && (
                            <div className="mt-3 ml-4 space-y-2 border-l-2 border-slate-700 pl-4">
                                <a
                                    href="/assistant"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block text-xs text-slate-400 hover:text-white"
                                >
                                    Assistant
                                </a>
                                <a
                                    href="/cards"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block text-xs text-slate-400 hover:text-white"
                                >
                                    Flashcards
                                </a>

                            </div>
                        )}
                    </div> */}

                    {/* Mobile Subscribe */}
                    {/* Mobile Assistant */}
                    <Show when={(has) => has({ plan: 'pro' }) || has({ plan: 'elite' }) || isAdmin}>
                        <Link
                            href="/assistant"
                            onClick={handleLinkClick}
                            className="block text-amber-400 hover:text-amber-300 text-sm uppercase tracking-widest font-bold"
                        >
                            Assistant
                        </Link>
                    </Show>
                    <ShowIfRole>
                        <Link
                            href="/subscribe"
                            onClick={handleLinkClick}
                            className="block text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                        >
                            Subscribe
                        </Link>
                    </ShowIfRole>
                    {role === "accepted_member-no" && false && (
                        <Link
                            href="/membership"
                            onClick={handleLinkClick}
                            className="block text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                        >
                            Membership
                        </Link>
                    )}
                    {role !== "accepted_member" && false && (
                        <Show when="signed-in" >
                            <Link
                                href="/apply"
                                onClick={handleLinkClick}
                                className="block text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold"
                            >
                                Apply
                            </Link>
                        </Show>
                    )}




                    {/* Mobile Auth */}
                    <Show when="signed-out">
                        <div className="pt-4 border-t border-slate-800 flex flex-col gap-4">
                            <SignInButton>
                                <button className="text-left text-slate-300 hover:text-white text-sm uppercase tracking-widest font-bold">
                                    Sign In
                                </button>
                            </SignInButton>
                            <SignUpButton>
                                <button className="bg-amber-800 hover:bg-amber-900 text-white text-xs uppercase tracking-widest font-bold px-5 py-3 rounded-sm w-full text-center">
                                    Sign Up
                                </button>
                            </SignUpButton>
                        </div>
                    </Show>
                </div>
            )}
        </header>
    )
}

export default NewHeader
